import {useEffect} from 'react'
import {notification} from 'antd'
import http from '@/biz/http.mjs'

export default ai => {
    const {status} = ai.getLastMessage() ?? {}

    useEffect(
        () => {
            const workflowInstanceId = ai.getWorkflowInstanceId()

            if (! workflowInstanceId || 'receiving' !== status) {
                return
            }

            (async () => {
                const warning = await http.post(
                    '/ai/chatWarningMessage',
                    {pkid: workflowInstanceId}
                )

                if (warning) {
                    notification.warn({
                        description: warning,
                        duration: null,
                        message: '警告',
                    })
                }
            })()
        },

        [status]
    )
}
